module.exports = __webpack_public_path__ + "img/insurita-experience-two.85dd3d62.svg";